import React from "react";

/**
 * CornerCell
 * The top-left "corner" cell of the grid — sits where the column-headers
 * row meets the row-headers column.  Sticky on both axes so it stays in
 * place when the user scrolls either direction.
 */
function CornerCell() {
  return <th className="corner-cell" />;
}

export default React.memo(CornerCell);
